export const CART_SUCCESS = "CART_SUCCESS";

export const EMPTY_CART = "EMPTY_CART";
export const UPDATE_QUANTITY = "UPDATE_QUANTITY";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
